import FirebaseModel from "@/Store/ORM/FirebaseORM/FirebaseModel";
export default class BillingInvoice extends FirebaseModel {
	static entity = 'billingInvoices';
	static baseCollection = this.firestore.collection('billing_invoices');
	static fields(){
		return {
			customer_id: this.attr(null),
			customer_name: this.attr(null),
			due_date: this.attr(null),
			invoice_date: this.attr(null),
			invoice_id: this.number(0),
			exported: this.boolean(false),
			invoice_items: this.attr([]),
			...super.fields()
		}
	}
}
